import { HttpClient, type HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { REWARDS_CONTENT_CONFIG } from '@icweb-service-marketplace/rewards-content';
import { MONTHLY_STATEMENT_CONTENT_CONFIG } from '@monthly-statement-content';
import { type Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  private readonly http = inject(HttpClient);
  readonly rc_config = inject(REWARDS_CONTENT_CONFIG);
  readonly ms_config = inject(MONTHLY_STATEMENT_CONTENT_CONFIG);
  readonly REWARDS_CENTER_LAYOUT_KEY = '/csconfig/ic_marketplace_layout.json';
  readonly MONTHLY_STATEMENT_KEY = '/csconfig/monthly_statement_web_landing_page.json';

  getContent<T>(baseUrl: string, key: string): Observable<T> {
    const url = `${baseUrl}${key}`;

    return this.http.get<T | { entry: T }>(url).pipe(
      catchError(this.handleError(url)),
      map((payload) => {
        const entry = payload != null && typeof payload === 'object' && 'entry' in payload ? payload.entry : payload;

        if (entry == null) {
          throw new Error('Invalid content payload');
        }

        return entry;
      }),
    );
  }

  handleError(resource: string) {
    return (error: HttpErrorResponse): Observable<never> =>
      throwError(() => new Error(`Failed to fetch ${resource}: ${error.status}`));
  }
}
